import React from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import {GlobalHeaderButtons} from "../PageLayout/GlobalHeaderButtons";
import {getInfoByClientType} from "./accountPageFunctions";

class AccountPageHeader extends React.Component {

  render() {

    const {accountPageInfoIsSet} = this.props;

    let pageInfo = {
      prefix: "",
      headerText: ""
    };

    if (accountPageInfoIsSet) {
      const {clientType, clientSubType, entityId} = this.props.accountPageInfo;
      pageInfo = getInfoByClientType(clientType, clientSubType, entityId);
    }

    return (
      <div className="app-header app-header-adj new-account-header">
        <GlobalHeaderButtons/>
        <div className="lightbox-header-container">
          <div className="lightbox-title-block">
            {accountPageInfoIsSet ? (
              <h1 id="PageTitle">
                <FormattedMessage id={pageInfo.prefix}/> <FormattedMessage id={pageInfo.headerText}/>
              </h1>
            ) : null}
            {accountPageInfoIsSet ? <p><FormattedMessage id="account.title.description"/></p> : null}
          </div>
        </div>
      </div>
    )
  }

}

const mapStateToProps = (store) => {
  return {
    accountPageInfoIsSet: store.accountState.accountPageInfoIsSet,
    accountPageInfo: store.accountState.accountPageInfo
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(AccountPageHeader);
